export * from './src/datepicker.module';



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/angular2-material-datepicker/index.ts